import type { GTMEventReturnType } from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';

type PaneLocation = 'filter' | 'map';

interface GTMOverviewFilterPaneOpenReturnType extends GTMEventReturnType {
    pane_location: PaneLocation;
}

interface GTMOverviewFilterPaneOpenData {
    location: PaneLocation;
}

export default class GTMOverviewFilterPaneOpenModel extends GTMBaseModel {
    public static parseToGTMData({
        location
    }: GTMOverviewFilterPaneOpenData): GTMOverviewFilterPaneOpenReturnType {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'web_event',
            ga4_event_name: 'overview_filter_pane_open',
            pane_location: location
        };
    }
}
